export default __webpack_public_path__ + "static/media/javascript.75220e22.png";